import cx from 'classnames';

type Props = {
    className?: string;
}

const DOT_CLASSES = 'tw-content-[""] tw-rounded-full tw-w-1 tw-h-1 tw-mx-2';

export const DotLineDivider: React.FC<Props> = ({className = 'tw-bg-dark'}) => (
    <div className={cx(DOT_CLASSES, className)} />
);
